<template>
	<section class="content">
		<div class="row">
			<div class="col-md-12">
				<div class="box box-primary">
					<div class="box-header with-border">
						<h3 class="box-title">
							<b>Boletos da Garantia</b>
						</h3>
					</div>
					<div class="box-body">
						<div class="row">
							<div class="col-md-12">
								<h4>Dados da Solicitação</h4>

								<table class="table table-bordered table-hover" role="grid">
									<thead>
										<tr role="row">
											<th style="width: 12%">Protocolo</th>
											<th style="width: 17%">Data</th>
											<th style="width: 32%">Pessoa</th>
											<th style="width: 16%">Cpf/Cnpj</th>
											<th style="width: 7%">Quant.</th>
											<th style="width: 16%">Situação</th>
										</tr>
									</thead>
									<tbody>
										<tr role="row" class="odd">
											<td>{{ dados.id }}-{{ dados.digito }}</td>
											<td>{{ dados.data | dataHoraFormatada }}</td>
											<td>{{ dados.pessoa.nome_razao }}</td>
											<td>{{ dados.pessoa.cpf_cnpj }}</td>
											<td>{{ dados.boletos.length }}</td>
											<td>
												<strong :class="dados.status">{{
													dados.status == "APROVADO" &&
													dados.libera_boleto != "S"
														? "PRÉ APROVADO"
														: dados.status
												}}</strong>
											</td>
										</tr>
									</tbody>
								</table>

								<h4>Duplicatas e Boletos</h4>

								<button
									v-if="dados.libera_boleto == 'S'"
									style="float: right; margin-bottom: 10px; margin-left: 10px"
									class="btn btn-info"
									@click="getCarne(dados.id)"
									title="Imprimir carnê"
								>
									<i class="fa fa-fw fa-barcode"></i>
									<strong>Imprimir Carnê</strong>
								</button>
								<button
									style="float: right; margin-bottom: 10px"
									class="btn btn-warning"
									@click="getDuplicatas(dados.id)"
									title="Imprimir duplicata"
								>
									<i class="fa fa-fw fa-list"></i>
									<strong>Imprimir Duplicatas</strong>
								</button>
								<button
									style="float: right; margin-bottom: 10px; margin-right: 10px"
									class="btn btn-success"
									@click="showModalAssinatura = true"
									title="Assinatura digital"
								>
									<i class="fa fa-fw fa-send"></i>
									<strong>Assinatura digital</strong>
								</button>
								<table class="table table-bordered table-hover" role="grid">
									<thead>
										<tr role="row">
											<th style="width: 8%">Parcela</th>
											<th style="width: 43%">Valor</th>
											<th style="width: 43%">Vencimento</th>
											<th style="width: 6%">Ação</th>
										</tr>
									</thead>
									<tbody>
										<tr
											v-for="(boleto, key) in dados.boletos"
											:key="boleto.id"
											role="row"
											class="odd"
										>
											<td>{{ key + 1 }}ª</td>
											<td>{{ boleto.valor | numberFormat(2, ",", ".") }}</td>
											<td>{{ boleto.vencimento | dataFormatada }}</td>
											<td>
												<!--
											<button class="btn btn-warning btn-sm" @click="getDuplicata(boleto.id)" title="Imprimir Duplicata">
												<i class="fa fa-fw fa-list"></i>
											</button>
                      -->
												<button
													:disabled="
														dados.status == 'APROVADO' &&
														dados.libera_boleto != 'S'
													"
													class="btn btn-info btn-sm"
													@click="getBoleto(boleto.id)"
													title="Gerar Boleto"
												>
													<i class="fa fa-fw fa-barcode"></i>
												</button>
											</td>
										</tr>
									</tbody>
								</table>

								<div class="row">
									<div class="col-sm-12">
										<label>Upload de Duplicatas</label>
										<vue-dropzone
											ref="myVueDropzone"
											id="dropzone"
											:options="dropzoneOptions"
										></vue-dropzone>
									</div>
								</div>

								<div class="box-footer text-right" style="margin-top: 20px">
									<a class="btn btn-default">Voltar</a>
								</div>
							</div>
						</div>
					</div>
					<!-- /.box-body -->
				</div>
				<!-- /.box -->
			</div>
			<!-- /.col-md-12 -->
		</div>
		<!-- /.row -->
		<modal-assinatura
			v-if="showModalAssinatura"
			@close="showModalAssinatura = false"
			@assinatura="(email, telefone) => enviarParaAssinatura(email, telefone)"
		></modal-assinatura>
	</section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import modalAssinatura from "./modalAssinatura";

export default {
	data() {
		return {
			showModalAssinatura: false,
			dropzoneOptions: {
				url: `${this.$store.state.serverURI}/api/garantia/uploadDuplicata`,
				method: "POST",
				maxFiles: 12,
				maxFilesize: 50,
				timeout: 99999999999999,
				autoQueue: true,
				parallelUploads: 2,
				paramName: "arquivo",
				dictDefaultMessage:
					"Arraste ou selecione seus arquivos com a imagem das duplicatas devidamente assinadas pelo cliente",
				dictResponseError: "Servidor não configurado!",
				acceptedFiles: ".jpeg, .jpg, .png",
				headers: this.$store.getters.getHeaderAuthFile,
				withCredentials: true,
				sending: (file, xhr, formData) => {
					formData.append("garantia_id", this.$route.params.garantiaId);
				},
			},
			dados: {
				pessoa: {
					nome_razao: "",
					cpf_cnpj: "",
				},
				usuario: {
					empresa: {
						fantasia: "",
						razao: "",
					},
				},
			},
		};
	},
	mounted() {
		if (this.$route.params.garantiaId) {
			this.getDetalhe(this.$route.params.garantiaId);
		}
	},

	methods: {
		getDetalhe(garantiaId) {
			let config = this.$store.getters.getHeaderAuth;
			axios
				.get(
					`${this.$store.state.serverURI}/api/garantia/getById/${garantiaId}`,
					config
				)
				.then((response) => {
					this.dados = response.data;
					this.dados.boletos = this.dados.boletos.filter(
						(item) =>
							item.situacao != "CANCELADO SR" && item.situacao != "CANCELADO"
					);
				})
				.catch((error) => {
					this.$store.commit("throwException", error);
				});
		},
		getBoleto(boletoId) {
			window.open(
				`${this.$store.state.serverURI}/api/boleto/getBoleto/${boletoId}`,
				"_blank"
			);
		},
		getCarne(garantiaId) {
			window.open(
				`${this.$store.state.serverURI}/api/boleto/getCarneBoleto/${garantiaId}/1`,
				"_blank"
			);
		},
		getDuplicatas(garantiaId) {
			window.open(
				`${this.$store.state.serverURI}/api/boleto/getDuplicataAll/${garantiaId}`,
				"_blank"
			);
		},
		enviarParaAssinatura(email, telefone) {
			this.$swal({
				type: "warning",
				title: "Aguarde!",
				text: "Enviando documento para assinatura...",
				showConfirmButton: false,
			});
			this.showModalAssinatura = false;
			let config = this.$store.getters.getHeaderAuth;
			axios
				.post(
					`${this.$store.state.serverURI}/api/boleto/getDuplicataAssinatura/${this.dados.id}`,
					{
						email: email,
						telefone: telefone,
					},
					config
				)
				.then((response) => {
					this.$swal({
						type: "success",
						title: "Documento enviado com sucesso!",
						text: "O link para realizar assinatura foi enviado para o whatsapp informado!",
						showConfirmButton: true,
					});
				})
				.catch((error) => {
					console.log(error);
					this.$swal({
						type: "error",
						title: "Opz! Algo deu errado!",
						text: "Ocorreu um erro ao enviar o documento para assinatura!",
						showConfirmButton: true,
					});
				});
		},
	},
	watch: {},

	components: {
		vueDropzone: vue2Dropzone,
		modalAssinatura,
	},
};
</script>
<style scoped>
table tr td {
	text-transform: uppercase;
}
.APROVADO {
	color: blue;
}
</style>



// WEBPACK FOOTER //
// impressaoDetalhe.vue?74ab399f